import { Economy } from '@features/ForestOwner/Search/Overview/Economy/Economy.tsx'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/forestowner/$forestownerId/economy')({
  component: RouteComponent,
  staticData: {
    breadcrumb: 'Økonomi',
  },
})

function RouteComponent() {
  return <Economy />
}
